import * as v from "valibot";

import { rpcContract } from "../rpc";

export const createBrandRpcContract = rpcContract({
  name: "createBrand",
  paramsSchema: v.object({
    name: v.pipe(v.string(), v.minLength(1), v.maxLength(64)),
    fileId: v.optional(v.string()),
    metaPixelId: v.optional(v.string()),
  }),
  resultSchema: v.object({
    id: v.string(),
    name: v.string(),
    thumbnail: v.nullable(v.string()),
    hasMetaPixel: v.boolean(),
  }),
});

export type CreateBrandParams = v.InferOutput<(typeof createBrandRpcContract)["paramsSchema"]>;
export type CreateBrandResult = v.InferOutput<(typeof createBrandRpcContract)["resultSchema"]>;
